<template>
  <div class="container-fluid">
    <b-card class="">
      <b-card-title class="card-title-doorder my-2"
        >Retailers Requests</b-card-title
      >
    </b-card>

    <b-card>
      <b-table-simple
        class="table table-no-bordered table-hover doorderTable"
        id="retailersTable"
        hover
        responsive
      >
        <b-thead>
          <b-tr>
            <b-th>Number</b-th>
            <b-th>Date/Time</b-th>
            <b-th>Business Type</b-th>
            <b-th>Retailer Name</b-th>
            <b-th>Status</b-th>
            <b-th>Stage</b-th>
            <b-th class="text-center">Locations No.</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="retailer in retailers"
            :key="retailer.id"
            @click="clickRetailerRequestRow(retailer.id)"
          >
            <b-td>#{{ retailer.id }}</b-td>
            <b-td class="text-left dateTimeTd">{{
              parseDateTime(retailer.date_time)
            }}</b-td>
            <b-td>{{ retailer.business_type }}</b-td>
            <b-td>{{ retailer.name }}</b-td>
            <b-td>
              <span
                v-if="retailer.status == 'received'"
                class="orderStatusSpan receivedStatus"
                >Request recieved</span
              >
              <span
                v-if="retailer.status == 'reject'"
                class="orderStatusSpan missingStatus"
                >Rejected</span
              >
              <span
                v-if="retailer.status == 'completed'"
                class="orderStatusSpan completedStatus"
                >Completed</span
              >
            </b-td>
            <b-td>
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  style="width: 33.33%"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  v-if="retailer.status == 'received'"
                ></div>
                <div
                  class="progress-bar"
                  role="progressbar"
                  style="width: 66.66%"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  v-if="retailer.status == 'reject'"
                ></div>
                <div
                  class="progress-bar"
                  role="progressbar"
                  style="width: 100%"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  v-if="retailer.status == 'completed'"
                ></div></div
            ></b-td>
            <b-td class="text-center">{{ retailer.locations_count }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-card>
  </div>
</template>


<script>
import $ from "jquery";
import axios from "axios";
import moment from "moment";

var table;
export default {
  name: "DoorderRetailersRequests",
  components: {},
  data() {
    return {
      retailers: [],

      table: null,
    };
  },
  mounted() {
    // this.overlay_show = true;
    this.initTable();
    this.getRetailersRequests();

    //
  },
  methods: {
    getRetailersRequests() {
      // console.log("here call user list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);
      axios
        .get("/retailer/requests-list", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DOORDER",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          // console.log(table);
          // table.destroy();
          if (table != null) {
            table.destroy();
          }
          console.log(response);
          this.retailers = response.data;
          console.log(this.retailers);
          var temp = this;
          setTimeout(function () {
            // console.log(table);
            // console.log(table == null);
            if (table == null) {
              temp.initTable();
            } else {
              // console.log(table.data());
              temp.initTable();
              // console.log(table.data());
              // table.destroy();
              // $('#sampleTable').DataTable().clear()
              // $('#sampleTable').DataTable().destroy()
              //
            }
          }, 1000);
          this.overlay_show = false;
          // table.ajax.reload()
        });
    },
    initTable() {
      table = $("#retailersTable").DataTable({
        // sDom: 'flti<"table_selected_rows">p',
        // // buttons: [
        // //    'csv',
        // // ],
        ordering: false,
        info: true,
        destroy: true,
        responsive: true,
        // scrollY: "450px",
        // scrollCollapse: true,
        searching: true,
        lengthMenu: [
          [-1, 5, 10, 25, 50, 100],
          ["All", 5, 10, 25, 50, 100],
        ],
        // columns: this.$parent.columns,
        // data: this.$parent.rowsData,
        pagingType: "full_numbers",
        language: {
          // paginate: {
          //   previous: "<i class='fas fa-angle-left'></i>",
          //   next: "<i class='fas fa-angle-right'></i>",
          // },
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
            first: "<i class='fas fa-angle-double-left'></i>",
            last: "<i class='fas fa-angle-double-right'></i>",
          },
          search: "",
          searchPlaceholder: "Search ",
        },
      });

      // $("#selectAll").change(function () {
      //   console.log(table.rows());

      //   if (this.checked) {
      //     table.rows().every(function () {
      //       $(this.node()).addClass("selected");
      //       $(this.node()).children().children().attr("checked", "checked");
      //       console.log($(this.node()));
      //       console.log($(this.node()).children());
      //       console.log($(this.node()).children().children());
      //     });
      //   } else {
      //     table.rows().every(function () {
      //       $(this.node()).removeClass("selected");
      //       $(this.node()).children().children().attr("checked", false);
      //     });
      //   }
      //   console.log($('input[name="selectedUsers[]"]:checked'));
      //   $("#selectAll").val(this.checked);
      // });
    },
    parseDateTime(date) {
      //console.log(date);
      let dateTime = "";
      //let parseDate = new Date();
      let date_moment = new moment();
      if (date != null && date != "") {
        //parseDate = new Date(date);
        date_moment = new moment(date, "DD-MM-yyyy HH:mm");
      }
      //moment(event.start_date, "DD-MM-yyyy").toDate()
      dateTime = date_moment.format("DD MMM YY HH:mm");
      return dateTime;
    },
    clickRetailerRequestRow(id) {
      console.log("click retailer request " + id);
      this.$router.push({
        name: "DoorderRetailerSingleRequest",
        params: { id },
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/retailers/RequestsList.vue